import usePaginationParams from 'app/hooks/usePaginationParams';
import { FilterParams } from 'app/types/Filters';
import { FilterProps } from 'components/Dashboard/types';
import { useAppSelector } from 'store/hooks';
import { selectModelsApi } from 'store/exec/execSlice';

import { Button, Checkbox, DatePicker, Input, Form, Select, Space } from 'antd';
import dayjs from 'dayjs';
import React from 'react';

const DockerImagesFilter: React.FC<FilterProps> = ({ onApply, hideModelApi }) => {
  const modelsApi = useAppSelector(selectModelsApi);
  const [ form ] = Form.useForm<FilterParams>();
  const {
    modelParam,
    modelApiParam,
    namedModelsParam,
    isSandboxParam,
    isCvParam,
    pushDateParam,
    setFilters,
    clearFilters,
  } = usePaginationParams();

  const onReset = () => {
    form.setFieldValue('model', undefined);
    form.setFieldValue('modelApi', []);
    form.setFieldValue('namedModels', []);
    form.setFieldValue('isSandbox', false);
    form.setFieldValue('isCv', false);
    form.setFieldValue('pushDate', undefined);
    clearFilters();
  };

  const onFinish = (values: FilterParams) => {
    setFilters(values);
    onApply();
  };

  return (
    <Form
      form={form}
      name="dockerImagesFilter"
      layout="vertical"
      requiredMark={false}
      onFinish={onFinish}
      style={{ width: 290 }}
      initialValues={{
        model: modelParam || undefined,
        modelApi: modelApiParam !== '' ? modelApiParam.split(',') : [],
        namedModels: namedModelsParam !== '' ? namedModelsParam.split(',') : [],
        isSandbox: isSandboxParam,
        isCv: isCvParam,
        pushDate: pushDateParam ? dayjs(pushDateParam) : null,
      }}
    >
      <Form.Item name="model" label="Model id">
        <Input placeholder="Enter model id" />
      </Form.Item>

      {!hideModelApi && (
        <Form.Item name="modelApi" label="Model API">
          <Select placeholder="Select model API" mode="multiple" options={modelsApi} allowClear />
        </Form.Item>
      )}

      <Form.Item name="namedModels" label="Named models">
        <Select placeholder="Enter named models" mode="tags" />
      </Form.Item>

      <Form.Item valuePropName="checked" name="isCv">
        <Checkbox>Clinical Validated</Checkbox>
      </Form.Item>

      <Form.Item valuePropName="checked" name="isSandbox">
        <Checkbox>Is sandbox</Checkbox>
      </Form.Item>

      <Form.Item name="pushDate" label="Push date">
        <DatePicker format="YYYY/MM/DD" allowClear style={{ width: '100%' }} />
      </Form.Item>

      <Form.Item style={{ textAlign: 'right', marginBottom: 0 }}>
        <Space>
          <Button onClick={onReset}>
            Reset
          </Button>
          <Button type="primary" htmlType="submit">
            Apply
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default DockerImagesFilter;
